const defaultState = {isEnabled: false, currentLanguage: null}

export const multilingual = (state = defaultState) => {
  return state
}
